import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useState } from 'react'
import { CreateRegistyProps } from '../../features/manageRegistry/manageRegistryTypes'
import { isValidJson } from '../../services/manageRegistryService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { manageUpdateAccessObj } from '../../features/manageUpdateAccess/manageUpdateAccessTypes';

function CreateRegistry(props: CreateRegistyProps) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Registry"
    const CUR_COMPONENT_COMMON="commonPortal";
    const [showLoader,setShowLoader] = useState<boolean>(false);
    const [showErrors,setShowErrors] = useState<boolean>(false);
    function validateAllFields(){
        if(!props.registryState.registryName){
            return "Select a Registry Name";
        }
        if(!props.registryState.values || !isValidJson(props.registryState.values)){
            return "Registry Values must be valid JSON";
        }
        return "";
    }
    async function handleCreateRegistrySubmit() {
        try {
            setShowLoader(true);

            if (showErrors !== true) setShowErrors(true);
    
            const validationMessage = validateAllFields();
            if (validationMessage !== "") {
                setShowLoader(false);
                openPopup("Alert", validationMessage);
                return;
            }
            const api = `/v1/registry/data/${props.registryState.registryName}`; // to do 
            const apiType="POST";
            const requestBody=JSON.parse(props.registryState.values);
            validateWithOtp(
                async (verifiedUser?:manageUpdateAccessObj, verifyResponse?:any) => {
                    try {
                        if (!verifyResponse || (verifyResponse.status !== 200 && verifyResponse.status !== 201)) {
                            throw new Error("OTP validation failed");
                        }else
                        if (verifyResponse && verifyResponse.status === 201 || verifyResponse.status === 200) {
                            openPopup("Success", "Registry Values added successfully");
    
                            props.setRegistryState({ registryName: "", values: "" });
                            setShowErrors(false);
                        } else {
                            throw new Error("API call failed");
                        }
                    } catch (apiError) {
                        console.error(apiError);
                        openPopup("Error", "Something went wrong during API call");
                    }
                },
                ["demo","prod","prod-egtm"],"admin",api,requestBody,apiType);
        } catch (err) {
            console.error(err);
            openPopup("Error", "Something went wrong");
        } finally {
            setShowLoader(false);
        }
    }
  return (
    <>
        <div className="manage-registry-label">
            <span>{translate(TranslationEnum.manage_registry,"New Registry")}</span>
        </div>
        <div className="manage-registry-inputs">
            <Autocomplete
            sx={{ width: "100%" }}
            value={props.registryState.registryName}
            disableClearable
            onChange={async (event, value: string | null) => {
                try{
                    if(value){
                        props.setRegistryState({ 
                            registryName: value, 
                            values: ""
                        });
                    }
                }catch(err){
                    openPopup("Error","Something went wrong");
                }
                
            }}
            options={props.registryNameOptions}
            renderInput={(params) => (
                <TextField
                {...params}
                label={translate(TranslationEnum.manage_registry,"Select Registry Name")}
                error={ showErrors  && !Boolean(props.registryState.registryName) }
                helperText={ showErrors  && !Boolean(props.registryState.registryName) && "Please select a registry name"}
                />
            )}
            />
            <TextField
                id="outlined-multiline-flexible"
                label="Registry Values"
                multiline
                rows={8}
                maxRows={8}
                value={ 
                    props.registryState.values
                }
                onChange={(event) => {
                    props.setRegistryState({...props.registryState, values: event.target.value })
                }}
                error={showErrors && !isValidJson(props.registryState.values)}
                helperText={
                    showErrors &&
                    !isValidJson(props.registryState.values) &&
                    "Please enter a valid json"
                }
            />
            <div className="manage-registry-buttons">
                <button
                    className="manage-registry-update-button"
                    disabled={showLoader}
                    onClick={() => {
                        props.openConfirmPopup("Are you sure you want to add this new registry value?",handleCreateRegistrySubmit);
                    }}
                >
                    {showLoader? (
                    <div>
                        <CircularProgress size={15} color="inherit" />
                        <span className="circular-progress-container "> {translate(TranslationEnum.common_portal,"SEND")}</span>
                    </div>
                    ) : (
                    <> {translate(TranslationEnum.common_portal,"SEND")}</>
                    )}
                </button>
            </div>
        </div>
    </>
  )
}

export default CreateRegistry